import { OnInit } from '@angular/core';
import { ThemeSettingService } from '../services/theme-setting.service';
import { HttpClient } from '@angular/common/http';
import { EnvService } from '../env.service';
var VendorApplicationsComponent = /** @class */ (function () {
    function VendorApplicationsComponent(themeSettingService, http, env) {
        this.themeSettingService = themeSettingService;
        this.http = http;
        this.env = env;
        this.isBusy = false;
        this.serviceUrl = this.env.servicePath;
        this.userGuide = this.env.allowSupplierApplication;
    }
    VendorApplicationsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var themes = this.themeSettingService.getTheme();
        this.loaderConfig = themes;
        this.isBusy = true;
        this.http.get("assets/external-html/vendor-applications.html", { responseType: "text" }).subscribe(function (result) {
            _this.vendorApplications = result;
            _this.isBusy = false;
        }, function (error) {
            _this.isBusy = false;
        });
    };
    return VendorApplicationsComponent;
}());
export { VendorApplicationsComponent };
